import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FooterComponent {

    @Input() year;
    @Input() inPageFooter: boolean;

    ngOnInit() {}

    onActivate(event) {
        window.scrollTo(0, 0);
    }
}